(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("brandsPredefinedSetsService", BrandsPredefinedSetsService);

    BrandsPredefinedSetsService.$inject = ['$q'];
    function BrandsPredefinedSetsService($q) {

        var self = this;
        var PREDEFINED_SET_TYPE = 'PREDEFINED_SET';


        var parseFilters = function (sets) {

            var parsedResult = [];

            (sets || []).forEach(function (item) {

                var filters = {};
                item.filters.forEach(function (item) {
                    var filterValue = JSON.parse(item.value);
                    filters[filterValue.key] = filterValue.value;
                });

                var set = {
                    id: item.id,
                    title: item.title,
                };

                parsedResult.push( $.extend(set, filters))
            });

            return parsedResult;

        };



        var createPayload = function (title, brands) {

            var value = {
                key: 'brands',
                value: brands
            };

            var payload = {
                type: PREDEFINED_SET_TYPE,
                title: title,
                filters: [{
                    value: JSON.stringify(value)
                }]
            };

            return payload;
        };


        self.getPredefinedSets = function (brandId) {

            var defer = $q.defer();

            var params = {
              type: PREDEFINED_SET_TYPE
            };

            ReportingManagementAPI
                .getReportsFilters(brandId, params)
                .then(function (result) {
                    defer.resolve(parseFilters(result.reports));
                })
                .catch(function (err) {
                    defer.reject(err);
                });

            return defer.promise;
        };

        self.createPredefinedSet = function (brandId, title, brands) {

            var defer = $q.defer();

            var payload = createPayload(title, brands);

            ReportingManagementAPI
                .createReportFilters(brandId, payload)
                .then(function (result) {
                    defer.resolve(result);
                })
                .catch(function (err) {
                    defer.reject(err);
                });

            return defer.promise;

        };

        self.updatePredefinedSet = function (brandId, setId, title, brands) {

            var defer = $q.defer();

            var payload = createPayload(title, brands);

            ReportingManagementAPI
                .setReportFilters(brandId, setId, payload)
                .then(function (result) {
                    defer.resolve(result);
                })
                .catch(function (err) {
                    defer.reject(err);
                });

            return defer.promise;

        };

        self.deletePredefinedSet = function (brandId, setId) {

            var defer = $q.defer();

            var params = {
                type: PREDEFINED_SET_TYPE
            };

            ReportingManagementAPI
                .deleteReportFilters(brandId, setId, params)
                .then(function (result) {
                    defer.resolve(result);
                })
                .catch(function (err) {
                    defer.reject(err);
                });

            return defer.promise;

        }

    }



})();
